import React, { useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { Box, Button, Grid } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import Compressor from 'compressorjs';

import { encodeBase64 } from '../../helpers/file';

const baseStyle: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 5,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  outline: 'none',
  transition: 'border .5s ease-in-out',
  minHeight: '30vh',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const imgStyle = {
  maxHeight: '25vh',
  maxWidth: '100%',
  borderRadius: 25,
};

const Dropzone = ({
  children,
  onChange,
  onNext,
  optional,
  hideContinueBtn,
  preview,
  getFile,
  disabled,
}: any) => {
  const [files, setFiles] = useState<any[]>([]);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: 'image/*',
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      if (getFile) {
        new Compressor(acceptedFiles[0], {
          quality: 0.8,
          maxWidth: 1024,
          maxHeight: 768,
          success: (compressedResult: any) => {
            onChange(
              new File([compressedResult], compressedResult.name, {
                ...compressedResult,
              })
            );
          },
        });
      } else {
        new Compressor(acceptedFiles[0], {
          quality: 0.8,
          maxWidth: 1024,
          maxHeight: 768,
          success: (compressedResult: any) => {
            encodeBase64(compressedResult, (result: any) => onChange(result));
          },
        });
      }

      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const thumbs = files.map((file: any) => (
    <img style={imgStyle} key={file.name} src={file.preview} alt={file.name} />
  ));

  const reset = () => {
    setFiles([]);
  };

  const nextStep = () => {
    reset();
    onNext(!files.length);
    onChange('');
  };

  return (
    <>
      <div className="container">
        <div {...getRootProps({ style: style as any })}>
          <input {...getInputProps()} />
          {files.length || preview ? (
            preview ? (
              <img
                style={imgStyle}
                src={URL.createObjectURL(preview)}
                alt={preview.name}
              />
            ) : (
              thumbs
            )
          ) : (
            children
          )}
        </div>
      </div>
      {!hideContinueBtn && (
        <Grid container justify="center">
          <Grid item xs={12} sm={7}>
            <Box my={3} textAlign="center">
              <Button
                onClick={nextStep}
                disabled={
                  disabled === false ? disabled : !optional && !files[0]
                }
                variant="contained"
                color="primary"
              >
                Continuar
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Dropzone;
